import type { AgentBuilderResponse } from '@onefootprint/request-types/dashboard';

const stash = new Map<string, AgentBuilderResponse>();

export const stashCreatedBuilder = (response: AgentBuilderResponse): void => {
  stash.set(response.agentId, response);
};

export const takeStashedBuilder = (agentId: string): AgentBuilderResponse | undefined => {
  const response = stash.get(agentId);
  stash.delete(agentId);
  return response;
};
